import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=6ac6e28e&scoped=true"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"
import style0 from "./Groups.vue?vue&type=style&index=0&id=6ac6e28e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac6e28e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac6e28e')) {
      api.createRecord('6ac6e28e', component.options)
    } else {
      api.reload('6ac6e28e', component.options)
    }
    module.hot.accept("./Groups.vue?vue&type=template&id=6ac6e28e&scoped=true", function () {
      api.rerender('6ac6e28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Groups.vue"
export default component.exports